import { createStorage } from '../lib/storage'
import { RoomLastMessage } from '$logic/room-last-message/types'

export const [roomLastMessageStorage, roomLastMessageReducer] = createStorage<
  RoomLastMessage
>('roomLastMessage')
